import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRemoteContent } from "@/lib/ContentContext";

export default function NewsPage() {
  const navigate = useNavigate();
  const siteContent = useRemoteContent();
  const [lang, setLang] = useState<"zh" | "en">("zh");
  const newsArticles = [...siteContent.newsArticles].sort((a, b) => a.order - b.order);
  const pageTitle = lang === "zh" ? "技术服务与企业动态" : "Technical Services & Corporate Updates";

  useEffect(() => {
    const storedLang = localStorage.getItem("site-lang");
    if (storedLang === "en" || storedLang === "zh") setLang(storedLang);
    document.title = lang === "zh" ? "技术服务与企业动态 | 星核动力" : "Technical Services & Corporate Updates | Xinghe Propulsion";
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#f3f4f2] text-[#111111]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 md:py-6">
        <div className="flex items-center justify-between mb-4 md:mb-5">
          <button onClick={() => navigate("/")} className="text-sm text-[#5a5a5a] hover:text-black cursor-pointer">
            {lang === "zh" ? "返回首页" : "Back Home"}
          </button>
          <button
            onClick={() => {
              const next = lang === "zh" ? "en" : "zh";
              setLang(next);
              localStorage.setItem("site-lang", next);
            }}
            className="text-xs px-3 py-1.5 rounded-full border border-black/20 text-black bg-white"
          >
            {lang === "zh" ? "EN" : "中文"}
          </button>
        </div>

        <div className="border border-black/10 bg-white px-5 py-3 md:px-7 md:py-3.5">
          <div className="mb-2.5 md:mb-3 border-b border-black/10 pb-2 md:pb-2.5">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#7b7b7b] mb-2">
              {lang === "zh" ? "Corporate News Index" : "Corporate News Index"}
            </div>
            <h1 className="text-[15px] md:text-[15px] leading-6 font-semibold tracking-[-0.01em]">{pageTitle}</h1>
          </div>

          <div className="hidden md:grid md:grid-cols-[88px_minmax(320px,1.25fr)_minmax(320px,0.95fr)] gap-[3em] px-1 pb-2.5 text-[13px] font-semibold uppercase tracking-[0.18em] text-[#555555] border-b border-black/10">
            <div>{lang === "zh" ? "序号" : "No."}</div>
            <div className="-ml-[3em]">{lang === "zh" ? "主题" : "Topic"}</div>
            <div className="-ml-[17em] pl-5">{lang === "zh" ? "简介" : "Summary"}</div>
          </div>

          <div>
            {newsArticles.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => navigate(`/news/${item.id}`)}
                className="w-full text-left border-b border-black/10 py-2.5 md:py-3 transition-colors hover:bg-black/[0.02] cursor-pointer"
              >
                <div className="grid grid-cols-1 md:grid-cols-[88px_minmax(320px,1.25fr)_minmax(320px,0.95fr)] gap-1.5 md:gap-[3em] items-start px-1">
                  <div className="text-[15px] leading-5 tracking-[0.12em] font-semibold text-[#666666] uppercase pt-0.5">
                    {item.order}
                  </div>
                  <div className="md:-ml-[3em] md:pr-6">
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
                      <h2 className="text-[14px] leading-5 font-semibold text-black">{lang === "zh" ? item.zhTitle : item.enTitle}</h2>
                      <span className="text-[14px] leading-5 text-[#8a8a8a]">{item.publishDate}</span>
                    </div>
                  </div>
                  <div className="relative md:-ml-[14em] pl-5 before:absolute before:left-0 before:top-0 before:bottom-0 before:w-px before:bg-black/10">
                    <p className="text-[14px] leading-5 font-normal text-[#444444] max-w-none md:pt-0">{lang === "zh" ? item.zhSummary : item.enSummary}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
